import { render } from "./WidgetGrid.vue?vue&type=template&id=7fe615d5"
import script from "./WidgetGrid.vue?vue&type=script&lang=js"
export * from "./WidgetGrid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__